import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Rocket } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const OnboardingBanner = () => {
    const { user } = useAuth();
    const location = useLocation();
    const [pending, setPending] = useState(null);

    useEffect(() => {
        if (user?.role !== 'admin') return;
        axios.get(`${API}/onboarding`).then((r) => setPending(r.data.completed ? null : r.data.step)).catch(() => setPending(null));
    }, [user?.role, location.pathname]);

    if (!pending || location.pathname === '/onboarding') return null;
    return (
        <Link to="/onboarding" className="mb-6 flex items-center gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm hover:bg-amber-500/15 transition-colors" data-testid="onboarding-banner">
            <Rocket className="w-5 h-5 text-amber-500 shrink-0" />
            <span>Te falta completar la configuración inicial (paso {pending} de 4).</span>
            <span className="ml-auto font-bold text-amber-500">Continuar</span>
        </Link>
    );
};
